import styles from './ScoopLinearProgress.module.scss'

/**
 * ScoopLinearProgress - A linear progress indicator component
 *
 * @param {Object} props - Component props
 * @param {number} [props.value=0] - Progress value (0-100) for determinate variant
 * @param {'determinate' | 'indeterminate'} [props.variant='determinate'] - Progress variant
 * @param {'primary' | 'secondary' | 'success' | 'error'} [props.color='primary'] - Color variant
 * @param {string} [props.className] - Additional CSS class names
 * @returns {JSX.Element} Linear progress bar component
 *
 * @example
 * // Determinate progress
 * <ScoopLinearProgress value={50} />
 *
 * @example
 * // Indeterminate loading
 * <ScoopLinearProgress variant="indeterminate" />
 *
 * @example
 * // Success color
 * <ScoopLinearProgress value={100} color="success" />
 */
export const ScoopLinearProgress = ({
    value = 0,
    variant = 'determinate',
    color = 'primary',
    className,
    ...props
}) => {
    const isIndeterminate = variant === 'indeterminate'

    const containerClassName = [
        styles.progressContainer,
        styles[color],
        isIndeterminate && styles.indeterminate,
        className,
    ]
        .filter(Boolean)
        .join(' ')

    return (
        <div
            className={containerClassName}
            role="progressbar"
            aria-valuenow={isIndeterminate ? undefined : value}
            aria-valuemin={0}
            aria-valuemax={100}
            {...props}
        >
            <div
                className={styles.progressBar}
                style={isIndeterminate ? undefined : { width: `${value}%` }}
            />
        </div>
    )
}

export default ScoopLinearProgress
